import { Loader, LoaderProps } from "@mantine/core";

import Center from "./Center";

const Spinner = (props: LoaderProps) => {
  return (
    <Center>
      <Loader {...props} />
    </Center>
  );
};

export default Spinner;
